import { connect } from 'react-redux';
import FastCreateObject from './FastCreateObject';
import { savePage } from '../../globalState/object/actions';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { WithObjectComponentHOC } from '../../HOC/WithObjectComponentHOC';
import { WithAppendHeaderAndFooterHOC } from '../../HOC/WithAppendHeaderAndFooterHOC';
import { WithSavingSnackBar } from '../../HOC/WithSavingSnackBar';
import { getOwnerSelectors, hasCheckedRules, hasCheckedServices } from '../ObjectContacts/selectors';
import { getPhotoDoneStatus } from '../../globalState/app/selectros';

let mapStateToProps = (state) => {
  return {
    description: state.object?.description?.description,
    photosToDB: state.object?.photo?.photos,
    isPhotoDone: getPhotoDoneStatus(state),
    owner: getOwnerSelectors(state),
    hasCheckedServices: hasCheckedServices(state),
    hasCheckedRules: hasCheckedRules(state),
    roomsListFromBd: state.object.rooms,
    calendar: state.subscriberCalendar,
    userVerified: state.user.verified,
    channelManager: state.object.channelManager
  };
};

export default compose(
  connect(mapStateToProps, {
    savePage,
  }),
  withRouter,
  WithObjectComponentHOC,
  WithAppendHeaderAndFooterHOC,
  WithSavingSnackBar
)(FastCreateObject);
